var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Eyes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eyes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    fillOpacity: 0.1,
    fill: "#000000",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8808395,7 C10.9839848,7 7,10.9839848 7,15.8808395 C7,20.7776943 10.9839848,24.7616791 15.8808395,24.7616791 C20.7776943,24.7616791 24.7616791,20.7776943 24.7616791,15.8808395 C24.7616791,10.9839848 20.7776943,7 15.8808395,7 Z M15.8808395,22.7366792 C12.1005697,22.7366792 9.02499989,19.6611093 9.02499989,15.8808395 C9.02499989,12.1005697 12.1005697,9.02499989 15.8808395,9.02499989 C19.6611093,9.02499989 22.7366792,12.1005697 22.7366792,15.8808395 C22.7366792,19.6611093 19.6611093,22.7366792 15.8808395,22.7366792 Z M15.9557645,10.3177598 C12.8712847,10.3177598 10.3619048,12.8271397 10.3619048,15.9116195 C10.3619048,18.9956944 12.8712847,21.5054792 15.9557645,21.5054792 C19.0398394,21.5054792 21.5496242,18.9960994 21.5496242,15.9116195 C21.5496242,12.8271397 19.0398394,10.3177598 15.9557645,10.3177598 Z M18.0621694,13.0373347 C18.1042894,13.2066247 18.1334494,13.3807747 18.1334494,13.5630247 C18.1334494,14.7654696 17.1590195,15.7398995 15.9565745,15.7398995 C15.9444245,15.7398995 15.9330845,15.7366595 15.9205295,15.7362545 C14.7354996,15.7168145 13.7796996,14.7529146 13.7796996,13.5630247 C13.7796996,13.3799647 13.8092646,13.2050047 13.8517896,13.0353097 C14.0858796,12.1017847 14.9177496,11.4063998 15.9209345,11.3897948 C15.9330845,11.3897948 15.9444245,11.3861498 15.9569795,11.3861498 C16.9767695,11.3861498 17.8260544,12.0904447 18.0621694,13.0373347 Z",
    id: "midground",
    fill: "#8596A1",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/Eyes.010ece0f3e742fedebc7e2e334435722.svg";
export { ForwardRef as ReactComponent };